import React from 'react';
import developerImage from '../assets/developer.jpeg';

const DeveloperPage = () => {
  return (
    <div className="container py-4">
      <div className="card shadow-sm border-0">
        <div className="card-body p-4">
          <h1 className="mb-5">Meet the Developer</h1>
          
          <div className="row mb-5">
            <div className="col-md-4 text-center mb-4 mb-md-0">
              <img 
                src={developerImage} 
                alt="Developer Profile"
                className="img-fluid rounded shadow-sm"
                style={{ maxWidth: '250px' }}
              />
            </div>
            
            <div className="col-md-8">
              <h2 className="mb-1">Ayush Gupta</h2>
              <p className="text-muted mb-4">Indie Hacker | BITSP'27</p>
              
              <div className="mb-4">
                <a href="https://www.linkedin.com/in/ayush-gupta-dev/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
          
          <div className="bg-light p-4 rounded">
            <h3 className="mb-3">A Note from the Developer</h3>
            <p className="mb-0">
              "Hey! I faced this problem where I just kept on reading and reading, thinking I was learning. But this Q&A-based approach helps me reflect on what I've actually learned. It's especially useful for courses where memorization is needed."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeveloperPage;